export default "__VITE_ASSET__q2fKeJqL__"